import React from 'react';
import { bool, func, object, shape, string } from 'prop-types';

import CancelButton from '../CancelButton';
import ConfirmButton from '../ConfirmButton';

import EditRuleFieldset from './EditRuleFieldset';
import NewRuleFieldset from './NewRuleFieldset';
import SidebarPanel from '../SidebarPanel';

import classes from './ModifyRuleFieldset.module.css';

const ButtonLabel = {
    [false]: 'Save',
    [true]:  'Saving...'
};

const RuleTitle = {
    // Rules with IDs
    [true]: {
        [true]:  'Edit Custom Rule',
        [false]: 'Manage K2A Rule'
    },
    // Rules without IDs
    [false]: {
        [true]:  'Create Rule',
        [false]: 'Add K2A Rule'
    }
};

const ModifyRuleFieldset = ({
    disabled,
    errors,
    isLoading,
    onBlur,
    onCancel,
    onChange,
    onPatch,
    readOnly,
    ruleTemplates,
    submitting,
    touched,
    values,
    ...props
}) => {
    const isSubmittable =
        !disabled &&
        !isLoading &&
        !submitting &&
        ((values.id && !readOnly) || !values.id);

    let confirmBtnLabel = ButtonLabel[submitting];
    if (isLoading) {
        confirmBtnLabel = 'Loading...';
    }

    let Fieldset = NewRuleFieldset;
    if (values.id) {
        Fieldset = EditRuleFieldset;
    }

    return (
        <SidebarPanel
            id="sidebar-custom-rule"
            title={RuleTitle[Boolean(values.id)][values.custom]}
            titleIconSrc="/assets/images/rulesIconColor.svg"
        >
            <div
                aria-labelledby="sidebar-custom-rule"
                className={classes.fieldset}
                role="group"
            >
                <Fieldset
                    disabled={disabled}
                    errors={errors}
                    isLoading={isLoading}
                    onBlur={onBlur}
                    onChange={onChange}
                    onPatch={onPatch}
                    readOnly={readOnly}
                    ruleTemplates={ruleTemplates}
                    touched={touched}
                    values={values}
                    {...props}
                />
                <footer className={classes.footer}>
                    <CancelButton
                        className={classes.button}
                        onClick={onCancel}
                    />
                    <ConfirmButton
                        className={classes.button}
                        color="primary"
                        disabled={!isSubmittable}
                        isLoading={isLoading}
                        label={confirmBtnLabel}
                        type="submit"
                        variant="contained"
                    />
                </footer>
            </div>
        </SidebarPanel>
    );
};

ModifyRuleFieldset.defaultProps = {
    editable:  true,
    errors:    {},
    isLoading: false,
    onBlur:    () => {},
    onCancel:  () => {},
    readOnly:  false,
    touched:   {},
    values:    {
        custom:  true,
        enabled: false,
        name:    ''
    },
    submitting: false
};

ModifyRuleFieldset.propTypes = {
    editable: bool,
    errors:   shape({
        enabled: string,
        name:    string
    }),
    isLoading:     bool,
    onBlur:        func,
    onChange:      func,
    onCancel:      func,
    readOnly:      bool,
    ruleTemplates: object,
    touched:       shape({
        enabled: bool,
        name:    bool
    }),
    values: shape({
        custom:  bool,
        enabled: bool,
        name:    string
    }),
    submitting: bool
};

export default ModifyRuleFieldset;
